import React, { useEffect, useState } from 'react';
import  { Redirect } from 'react-router-dom'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import { Button, Modal } from 'react-bootstrap'

const Index = props => {

    const [redirectLink, setRedirectLink] = useState('/login');
    const [alreadyLoaded, setAlreadyLoaded] = useState(false);
    const [hasAlert, setHasAlert] = useState(false);


    useEffect(() => {
        let hasOnlineActivity = false
        let currentActivityId = ''

        if (AuthService.getCurrentUser() && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name) {
            UserService.getActivities({
                'status': 'RUNNING',
                'domain': AuthService.getCurrentUser() && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name ? AuthService.getCurrentUser().domain.name : '',
                'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.id ? AuthService.getCurrentUser().room.id : '',
            }).then((res) => {
                if (res.data.data.length > 0) {
                    currentActivityId = res.data.data[0].id
                    hasOnlineActivity = true
                }
            }).then((res) => {
                if (AuthService.getCurrentUser() && AuthService.getUserRole() === 'headmaster') {
                    setRedirectLink('/report')
                } else if (AuthService.getCurrentUser() && AuthService.getUserRole() === 'teacher' && hasOnlineActivity) {
                    setHasAlert(true)
                    setRedirectLink(`/activity/live/${currentActivityId}`)
                } else if (AuthService.getCurrentUser() && (AuthService.getUserRole() === 'teacher' || AuthService.getUserRole() === 'student')) {
                    setRedirectLink(`/activity`)
                }
                setAlreadyLoaded(true)
            })
        } else {
            setRedirectLink(`/login`)
            setAlreadyLoaded(true)
        }
    }, [])

    if (alreadyLoaded && redirectLink) {
        if (hasAlert) {
            return (<Modal
                show={hasAlert}
                onHide={() => { setHasAlert(false); }}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="alert-modal"
            >
                    <div>
                        <Modal.Header closeButton className="alert-header">
                        </Modal.Header>
                        <Modal.Body className="font-sarabun text-center pb-4 pt-0">
                            <p>ไม่สามารถ Back กลับได้ ต้องดำเนินกิจกรรมให้จบก่อน</p>
                            <Button className="bluebtn d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => { setHasAlert(false); }}>กลับกิจกรรม</Button>
                        </Modal.Body>
                    </div>
            </Modal>)
        }
        return <Redirect to={{ pathname: redirectLink }} />
    }
    return ''
}

export default Index;